import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { configureAmplify } from './config/amplify'
import '@aws-amplify/ui-react/styles.css'
import './index.css'
import './styles/amplify-auth.css'

// Configure Amplify with Cognito settings
configureAmplify()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)